import { Point, Path, Rectangle } from 'paper';
import ToolShape from '../ToolShape';

export class MaterialCircle extends ToolShape {
    constructor(center, radius) {
        super('materialcircle', ['delete', 'select', 'resize-radius', 'move'], false);

        this.center = center;
        this.radius = radius;
    }

    get center() {
        return new Point({ x: this.centerX, y: this.centerY });
    }

    set center(center) {
        this.centerX = center.x;
        this.centerY = center.y;
    }

    get bounds() {
        return new Rectangle(this.center.x - this.radius, this.centerY - this.radius, this.radius * 2, this.radius * 2);
    }

    async updatePath() {
        let path =  new Path.Circle({
            center: this.center,
            radius: this.radius
        });

        path.rotation = this.rotation;
        this.linkTo(path);
        return path;
    }

    move(delta) {
        let newCenter = this.center.add(delta);
        this.centerX = newCenter.x;
        this.centerY = newCenter.y;
    }

    resize(size) {
        this.radius = size.height;
    }

    scale(ratio) {
        this.radius *= ratio;
    }

    clone() {
        return new MaterialCircle(
            this.center,
            this.radius
        )
    }

    referencePoint(){
        return this.center;
    }
}
